module.exports = "img/flags/TD.4b6c185.png";